import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    state => state.updateVacancy
)

export const selectIsCreateVacancyModalOpen = createSelector(
    baseSelector,
    (state) => state.isCreateVacancyModalOpen
)

export const selectIsUpdateVacancyModalOpen = createSelector(
    baseSelector,
    (state) => state.isUpdateVacancyModalOpen
)

export const selectIsDeleteVacancyModalOpen = createSelector(
    baseSelector,
    (state) => state.isDeleteVacancyModalOpen
)

export const selectCurrentVacancy = createSelector(
    baseSelector,
    (state) => state.currentVacancy
)

export const selectOnCreate = createSelector(
    baseSelector,
    (state) => state.onCreate
)

export const selectOnDelete = createSelector(
    baseSelector,
    (state) => state.onDelete
)

export const selectOnUpdate = createSelector(
    baseSelector,
    (state) => state.onUpdate
)

export const selectOnFormEdit = createSelector(
    baseSelector,
    (state) => state.onFormEdit
)

export const selectIsEditVacancyFormModalOpen = createSelector(
    baseSelector,
    (state) => state.isEditVacancyFormModalOpen
)